export default "__VITE_ASSET__DekT1zJJ__"